import { useEffect, useState } from 'react';
import { getCandidateEpisodes } from '../services/storage/candidateArchive';
import type { CandidateRecord } from '../types/market';

export interface CandidateHistoryState {
  loading: boolean;
  episodes: CandidateRecord[];
  error?: string;
}

export function useCandidateHistory(symbol: string): CandidateHistoryState {
  const [state, setState] = useState<CandidateHistoryState>({ loading: true, episodes: [] });

  useEffect(() => {
    let active = true;
    setState((current) => ({ ...current, loading: true, error: undefined }));
    const load = async (): Promise<void> => {
      try {
        const episodes = await getCandidateEpisodes(symbol, 12);
        if (active) setState({ loading: false, episodes });
      } catch (reason) {
        if (active) {
          setState({
            loading: false,
            episodes: [],
            error: `Local candidate history is unavailable: ${reason instanceof Error ? reason.message : 'storage error'}.`,
          });
        }
      }
    };
    void load();
    const timer = window.setInterval(() => void load(), 10_000);
    return () => {
      active = false;
      window.clearInterval(timer);
    };
  }, [symbol]);

  return state;
}
